import {
  GET_PRESCRIPTIONS_REQUEST,
  GET_PRESCRIPTIONS_SUCCESS,
  GET_PRESCRIPTIONS_FAILURE,
  UPDATE_DELIVERY_STATUS_REQUEST,
  UPDATE_DELIVERY_STATUS_SUCCESS,
  UPDATE_DELIVERY_STATUS_FAILURE,
  ADD_DELIVERY_ADDRESS_REQUEST,
  ADD_DELIVERY_ADDRESS_SUCCESS,
  ADD_DELIVERY_ADDRESS_FAILURE,
  SET_SELECTED_PRESCRIPTION,
  PRESCRIPTION_DOWNLOAD_REQUEST,
  PRESCRIPTION_DOWNLOAD_SUCCESS,
  PRESCRIPTION_DOWNLOAD_FAILURE,
  CLEAR_MEDICAL_ERRORS,
} from "../actions/medicalConstants";

const initialState = {
  // Prescriptions
  prescriptions: [],
  selectedPrescription: null,
  patient_details: null,
  medicines: [],
  delivery_details: [],
 
  // Loading states
  loading: false,
  updateLoading: false,
  addressLoading: false,
  downloadLoading: false,

  // Error states
  error: null,
  updateError: null,
  addressError: null,
  downloadError: null, 

  // Success states
  updateSuccess: false,
  addressSuccess: false,

  // Add this to track delivery details locally
  deliveryDetails: {},

  // Track selected medicines locally
  selectedMedicines: {},
};

const medicalReducer = (state = initialState, action) => {
  let updatedPatientDetails;
  let updatedPrescriptions;
  let updatedSelectedPrescription;

  switch (action.type) {
    // Get Prescriptions
    case GET_PRESCRIPTIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_PRESCRIPTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        prescriptions: action.payload.data || [],
        patient_details: action.payload.patient_details || null,
        medicines: action.payload.data.medicines || [],
        delivery_details: action.payload.delivery_details || [],
        error: null,
      };

    case GET_PRESCRIPTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        prescriptions: [],
        patient_details: null,
        medicines: [],
        delivery_details: [],
      };

    // Update Delivery Status
    case UPDATE_DELIVERY_STATUS_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateError: null,
        updateSuccess: false,
      };

    // case UPDATE_DELIVERY_STATUS_SUCCESS:
    //   return {
    //     ...state,
    //     updateLoading: false,
    //     updateSuccess: true,
    //     updateError: null,
    //     delivery_details: action.payload.delivery_details,
    //     prescriptions: state.prescriptions.map((prescription) =>
    //       prescription.prescription_id === action.payload.prescription_id
    //         ? {
    //             ...prescription,
    //             delivery_details: action.payload.delivery_details,
    //             updatedAt: new Date().toISOString()
    //           }
    //         : prescription
    //     ),
    //   };
    case UPDATE_DELIVERY_STATUS_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        updateSuccess: true,
        updateError: null,
    
        // update local prescription and medicines
        prescriptions: state.prescriptions.map((prescription) =>
          prescription.prescription_id === action.payload.prescription_id
            ? {
                ...prescription,
                ...action.payload,   // ✅ merge entire updated prescription object
                updatedAt: new Date().toISOString(),
              }
            : prescription
        ),
    
        // keep selectedPrescription in sync
        selectedPrescription:
          state.selectedPrescription?.prescription_id === action.payload.prescription_id
            ? { ...state.selectedPrescription, ...action.payload }
            : state.selectedPrescription,
    
        medicines: action.payload.medicines || state.medicines,
        delivery_details: action.payload.delivery_details || state.delivery_details,
      };
    
    case UPDATE_DELIVERY_STATUS_FAILURE:
      return {
        ...state,
        updateLoading: false,
        updateError: action.payload,
        updateSuccess: false,
      };

    // Add Delivery Address
    case ADD_DELIVERY_ADDRESS_REQUEST:
      return {
        ...state,
        addressLoading: true,
        addressError: null,
        addressSuccess: false,
      };

    case ADD_DELIVERY_ADDRESS_SUCCESS:
      // Update addresses in the selected prescription and all prescriptions
      updatedPrescriptions = state.prescriptions.map((prescription) => {
        if (
          prescription.patient_details.patient_id === action.payload.patient_id
        ) {
          return {
            ...prescription,
            patient_details: {
              ...prescription.patient_details,
              addresses: [
                ...(prescription.patient_details.addresses || []),
                action.payload,
              ],
            },
          };
        }
        return prescription;
      });

      // Update patient_details if it exists
      updatedPatientDetails = state.patient_details
        ? {
            ...state.patient_details,
            addresses: [
              ...(state.patient_details.addresses || []),
              action.payload,
            ],
          }
        : state.patient_details;

      // Update selectedPrescription if it exists and matches the patient_id
      updatedSelectedPrescription =
        state.selectedPrescription &&
        state.selectedPrescription.patient_details.patient_id ===
          action.payload.patient_id
          ? {
              ...state.selectedPrescription,
              patient_details: {
                ...state.selectedPrescription.patient_details,
                addresses: [
                  ...(state.selectedPrescription.patient_details.addresses ||
                    []),
                  action.payload,
                ],
              },
            }
          : state.selectedPrescription;

      return {
        ...state,
        prescriptions: updatedPrescriptions,
        patient_details: updatedPatientDetails,
        selectedPrescription: updatedSelectedPrescription,
        addressLoading: false,
        addressError: null,
        addressSuccess: true,
      };

    case ADD_DELIVERY_ADDRESS_FAILURE:
      return {
        ...state,
        addressLoading: false,
        addressError: action.payload,
        addressSuccess: false,
      };

    // Set Selected Prescription
    case SET_SELECTED_PRESCRIPTION:
      return {
        ...state,
        selectedPrescription: action.payload,
      };

    // Clear Errors
    case CLEAR_MEDICAL_ERRORS:
      return {
        ...state,
        error: null,
        updateError: null,
        addressError: null,
        updateSuccess: false,
        addressSuccess: false,
      };

    case "ADD_DELIVERY_DETAIL": {
      const { prescription_id, delivery_detail } = action.payload;
      const updatedPrescription =
        state.selectedPrescription &&
        state.selectedPrescription.prescription_id === prescription_id
          ? {
              ...state.selectedPrescription,
              delivery_details: [
                ...(state.selectedPrescription.delivery_details || []),
                delivery_detail,
              ],
            }
          : state.selectedPrescription;

      // Update selected medicines based on delivery detail
      const updatedSelectedMedicines = { ...state.selectedMedicines };
      delivery_detail.delivery_medicines.forEach((medicine) => {
        updatedSelectedMedicines[medicine.medicine_id] = {
          ...medicine,
          delivery_status: delivery_detail.delivery_status,
        };
      });

      return {
        ...state,
        selectedPrescription: updatedPrescription,
        deliveryDetails: {
          ...state.deliveryDetails,
          [prescription_id]: [
            ...(state.deliveryDetails[prescription_id] || []),
            delivery_detail,
          ],
        },
        selectedMedicines: updatedSelectedMedicines,
      };
    }

    case "UPDATE_SELECTED_MEDICINES":
      return {
        ...state,
        selectedMedicines: {
          ...state.selectedMedicines,
          ...action.payload,
        },
      };
   // download 
   // Download Prescription
case "PRESCRIPTION_DOWNLOAD_REQUEST":
  return {
    ...state,
    downloadLoading: true,
    downloadError: null,
  };

case "PRESCRIPTION_DOWNLOAD_SUCCESS":
  return {
    ...state,
    downloadLoading: false,
    downloadError: null,
  };

case "PRESCRIPTION_DOWNLOAD_FAILURE":
  return {
    ...state,
    downloadLoading: false,
    downloadError: action.payload,
  };


    case "RESET_SELECTED_MEDICINES":
      return {
        ...state,
        selectedMedicines: {},
      };

    default:
      return state;
  }
};

export default medicalReducer;